import { useMutation } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { OrderPhysicalPaymentCardInput } from '../../../../../../../__generated__/GQL';
import { CreditCardsDocument } from '../../../../../hooks/useCreditCards/creditCards.gql';
import { OrderPhysicalPaymentCardDocument } from './orderPhysicalPaymentCard.gql';

export const useOrderPhysicalPaymentCard = () => {
  const { companyProfileId, companyUserId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error(
      "'companyProfileId' is undefined in 'useOrderPhysicalPaymentCard'",
    );
  }

  if (!companyUserId) {
    throw new Error(
      "'companyUserId' is undefined in 'useOrderPhysicalPaymentCard'",
    );
  }

  const [orderPhysicalPaymentCardMutation, hook] = useMutation(
    OrderPhysicalPaymentCardDocument,
    {
      // Invalidate the cards list query to have the new card in it
      // when navigating back to the list after the order.
      refetchQueries: [
        {
          query: CreditCardsDocument,
          variables: { companyProfileId, companyUserId },
        },
      ],
    },
  );

  const orderPhysicalPaymentCard = async (
    input: Pick<
      OrderPhysicalPaymentCardInput,
      'shouldSendToCompanyAddress' | 'pin' | 'alias' | 'bankAccountId'
    >,
  ) =>
    orderPhysicalPaymentCardMutation({
      variables: {
        input: {
          companyProfileId,
          companyUserId,
          ...input,
        },
      },
    });

  return [orderPhysicalPaymentCard, hook] as const;
};
